import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';
import { AIDifficultyLevel } from '../../PlayWithAI/useJoinAiGameMutation.gql';

// 1. Define the mutation
const mutation = gql`
  mutation incrementGymAIPracticeGamesPlayed($input: IncrementGymAIPracticeGamesPlayedInput!) {
    incrementGymAIPracticeGamesPlayed(input: $input) {
      _id
      userId
      gameType
      aiDifficultyLevel
      played
      won
    }
  }
`;

// 2. Define TypeScript types for input and return shape
export interface IncrementGymAIPracticeGamesPlayedInput {
  aiDifficultyLevel: AIDifficultyLevel;
  gameType: GAME_TYPES_TYPE;
  userId: string;
}

export interface GymAIPracticeGame {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  aiDifficultyLevel: AIDifficultyLevel;
  played: number;
  won: number;
}

export interface MutationType {
  incrementGymAIPracticeGamesPlayed: GymAIPracticeGame;
}

// 3. Create the hook
export function useIncrementGymAIPracticeGamesPlayedMutation(
  options?: MutationHookOptions<MutationType, { input: IncrementGymAIPracticeGamesPlayedInput }>,
) {
  return useMutation<MutationType, { input: IncrementGymAIPracticeGamesPlayedInput }>(
    mutation,
    options,
  );
}
